import styled from "../../../__compat__/styled-components/main.entry.mjs.mjs";
import { StyledInput } from "../GenericOption/GenericOption.styles.mjs.mjs";
const checkmarkIcon = `url(data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 12.2l4.3 4.2 8.1-10.3" stroke="#000000" fill="none" />
  </svg>`)})`;
export const StyledCheckbox = styled(StyledInput).attrs({ type: 'checkbox' }).withConfig({ displayName: "auir-611444a-StyledCheckbox", componentId: "auir-611444a-m0l2dg" }) `
  border-radius: 0;
  position: relative;

  /* Checkmark */
  &::before {
    position: absolute;
    display: block;
    width: 24px;
    height: 24px;

    transform: scale(0);
    transform-origin: 50%;

    transition: transform 0.1s var(${(props) => props.theme.easing});

    content: '';
    mask: ${checkmarkIcon};
  }

  /* Checkmark checked */
  &:checked::before {
    background-color: var(
      ${(props) => props.theme.colors.interaction.secondary.filled}
    );

    transform: scale(1);
  }

  /* Checkmark invalid */
  &:invalid::before {
    background-color: ${(props) => props.invalid && `var(${props.theme.colors.ui.error})`};
  }

  /* Checkmark disabled */
  &:disabled::before {
    background-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.disabled}
    );
  }
`;
//# sourceMappingURL=Checkbox.styles.mjs.mjs.map